import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Library from "@/pages/Library";
import Coach from "@/pages/Coach";
import Workouts from "@/pages/Workouts";
import WorkoutDetail from "@/pages/WorkoutDetail";
import Session from "@/pages/Session";
import Progress from "@/pages/Progress";
import Profile from "@/pages/Profile";
import Program from "@/pages/Program";
import Messages from "@/pages/Messages";
import Admin from "@/pages/Admin";
import AdminUserDetail from "@/pages/AdminUserDetail";
import ResetPassword from "@/pages/ResetPassword";
import Subscribe from "@/pages/Subscribe";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import "@/App.css";

function Guarded({ children, bare = false }) {
  return (
    <ProtectedRoute>{bare ? children : <Layout>{children}</Layout>}</ProtectedRoute>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          position="top-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#141419",
              border: "1px solid #2A2A35",
              color: "#fff",
              borderRadius: 0,
            },
          }}
        />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/payment/success" element={<Guarded bare><PaymentSuccess /></Guarded>} />
          <Route path="/payment/cancel" element={<Guarded bare><PaymentCancel /></Guarded>} />
          <Route path="/subscribe" element={<Guarded><Subscribe /></Guarded>} />
          <Route path="/" element={<Guarded><Dashboard /></Guarded>} />
          <Route path="/profile" element={<Guarded><Profile /></Guarded>} />
          <Route path="/program" element={<Guarded><Program /></Guarded>} />
          <Route path="/library" element={<Guarded><Library /></Guarded>} />
          <Route path="/coach" element={<Guarded><Coach /></Guarded>} />
          <Route path="/workouts" element={<Guarded><Workouts /></Guarded>} />
          <Route path="/workouts/:id" element={<Guarded><WorkoutDetail /></Guarded>} />
          <Route path="/session/:id" element={<Guarded bare><Session /></Guarded>} />
          <Route path="/progress" element={<Guarded><Progress /></Guarded>} />
          <Route path="/messages" element={<Guarded><Messages /></Guarded>} />
          <Route path="/admin" element={<Guarded><Admin /></Guarded>} />
          <Route path="/admin/users/:id" element={<Guarded><AdminUserDetail /></Guarded>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
